"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
var MenuState_1 = require("./MenuState");
var ControlledMenu_1 = require("./ControlledMenu");
/**
 * @internal
 */
exports.Menu = function (props) { return (react_1.default.createElement(MenuState_1.MenuState, { opened: props.opened, defaultOpened: props.defaultOpened, onOpenedChange: props.onOpenedChange }, function (controlledProps) { return (react_1.default.createElement(ControlledMenu_1.ControlledMenu, { opened: controlledProps.opened, onOpenedChange: controlledProps.onOpenedChange, openAction: props.openAction, alignment: props.alignment, spacing: props.spacing, offset: props.offset, toggler: props.toggler, togglerWrapperClassName: props.togglerWrapperClassName, portalTarget: props.portalTarget, closeOnScroll: props.closeOnScroll }, isFunction_1.default(props.children)
    ? props.children({
        closeMenu: function () {
            return controlledProps.onOpenedChange({
                opened: false,
                source: "CLOSE_MENU_RENDER_PROP",
            });
        },
    })
    : props.children)); })); };
exports.Menu.defaultProps = {
    openAction: "click",
    alignment: ["bottom", "right"],
    closeOnScroll: false,
};
//# sourceMappingURL=Menu.js.map